import { Component } from '@angular/core';
import { NotificationProvider } from '../../providers/notification/notification';

@Component({
  selector: 'unread-notifications',
  templateUrl: 'unread-notifications.html'
})
export class UnreadNotificationsComponent {

  count: number = 0;

  constructor(private notificationProvider: NotificationProvider) {
    this.notificationProvider.unreadNotifications.subscribe(notifications => this.count = notifications);
  }

}



// WEBPACK FOOTER //
// ./src/components/unread-notifications/unread-notifications.ts